import styled, { css, keyframes } from 'styled-components';

interface DebugProps { $debug?: boolean }

interface WrapperLoaderProps extends DebugProps {
    $isVisible: boolean
    $shouldRender: boolean
}

interface ContentLoaderProps extends DebugProps {
    $isVisible: boolean
}

export const StyledWrapperLoader = styled.section<WrapperLoaderProps>`
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(3px);
    top: 0;
    left: 0;
    z-index: 10000;
    padding: 0;
    margin: 0;
    overflow: hidden;
    display: ${({ $shouldRender }) => $shouldRender ? 'flex' : 'none'};
    animation: ${({ $isVisible }) => $isVisible ? fadeIn : fadeOut} 0.5s ease-in-out;
    animation-fill-mode: forwards;
    align-items: center;
    justify-content: center;
    z-index: 99999999;
`;

export const StyledContentLoader = styled.section<ContentLoaderProps>`
    animation: ${({ $isVisible }) => $isVisible
    ? css`${slideInFromBottom} 0.5s ease-out, ${fadeIn} 0.5s ease-out`
    : css`${slideOutToBottom} 0.5s ease-in, ${fadeOut} 0.5s ease-in`};
`;

export const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

export const fadeOut = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`;

export const slideInFromBottom = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const slideOutToBottom = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%); 
    opacity: 0;
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled.svg`
  width: 50px;
  height: 50px;
  animation: ${rotate} 2s linear infinite;
  
  & .path {
    stroke: #E65802;
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;
